import { render, staticRenderFns } from "./MatchPairsContent.vue?vue&type=template&id=6de579c2&scoped=true&"
import script from "./MatchPairsContent.vue?vue&type=script&lang=js&"
export * from "./MatchPairsContent.vue?vue&type=script&lang=js&"
import style0 from "./MatchPairsContent.vue?vue&type=style&index=0&id=6de579c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de579c2",
  null
  
)

export default component.exports